import React, { useState, useEffect } from 'react';

interface AnimatedDurationProps {
  seconds: number;
  duration?: number;
}

const AnimatedDuration: React.FC<AnimatedDurationProps> = ({
  seconds,
  duration = 2000
}) => {
  const [currentSeconds, setCurrentSeconds] = useState(0);

  useEffect(() => {
    let startTime: number;
    let animationFrame: number;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      
      const currentValue = Math.floor(easeOutQuart * seconds);
      setCurrentSeconds(currentValue);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [seconds, duration]);

  const formatDuration = (totalSeconds: number): string => {
    if (totalSeconds === undefined || totalSeconds === null || isNaN(totalSeconds)) {
      return '0m 0s';
    }
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = Math.floor(totalSeconds % 60);
    return `${minutes}m ${remainingSeconds}s`;
  };

  return <span>{formatDuration(currentSeconds)}</span>;
};

export default AnimatedDuration;
